





































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminInvoiceForm from '@/modules/invoice/components/admin/AdminInvoiceForm.vue'
import AdminInvoiceItemForm from '@/modules/invoice-item/components/admin/AdminInvoiceItemForm.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import AdminInvoiceShowTabular from '@/modules/invoice/components/admin/AdminInvoiceShowTabular.vue'
import AdminInvoiceShowSideNavigation from '@/modules/invoice/components/admin/AdminInvoiceShowSideNavigation.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import AdminInvoiceItemTable from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemTable.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminInvoiceItemFormTable from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemFormTable.vue'
import AdminDownloadInvoiceButton from '@/modules/invoice/components/admin/AdminDownloadInvoiceButton.vue'
import AdminInvoiceBillingInfoTable
  from '@/modules/invoice/components/admin/billing-info-table/AdminInvoiceBillingInfoTable.vue'
import {
  TransactionGateWay,
  TransactionResourceType,
  TransactionStatus
} from '@/modules/transaction/models/transaction-resource.model'
import AdminTransactionInfo from '@/modules/transaction/components/admin/AdminTransactionInfo.vue'
import AdminTransactionShowTabular from '@/modules/transaction/components/admin/AdminTransactionShowTabular.vue'
import AdminTransactionSideNav from '@/modules/transaction/components/admin/AdminTransactionSideNav.vue'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import ConfirmDialog from '@/modules/common/dialog/components/shared/ConfirmDialog.vue'
import AdminTransactionPaidButton from '@/modules/transaction/components/admin/AdminTransactionPaidButton.vue'
import AdminTransactionRejectButton from '@/modules/transaction/components/admin/AdminTransactionRejectButton.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'تراکنش'
  },
  metaInfo: {
    title: 'تراکنش'
  },
  components: {
    AdminTransactionRejectButton,
    AdminTransactionPaidButton,
    ConfDialog: ConfirmDialog,
    Confirm,
    AdminTransactionSideNav,
    AdminTransactionShowTabular,
    AdminTransactionInfo,
    AdminInvoiceBillingInfoTable,
    AdminDownloadInvoiceButton,
    AdminInvoiceItemFormTable,
    SimpleHeader,
    AdminInvoiceItemTable,
    AdminUserInfoButton,
    AdminInvoiceShowSideNavigation,
    AdminInvoiceShowTabular,
    BaseCard,
    BaseInput,
    AdminInvoiceItemForm,
    AdminInvoiceForm,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class ShowPage extends Vue {
  @Prop() transactionData!: TransactionResourceType
  transaction: TransactionResourceType = this.initData()

  initData() {
    return this.transactionData
  }

  get isPaidAction() {
    return (this.transaction.data.gateway === TransactionGateWay.CARD)
      && (this.transactionData.data.status === TransactionStatus.PENDING ||
        this.transactionData.data.status === TransactionStatus.UNPAID)
  }

  get isRejectAction() {
    return (this.transactionData.data.status === TransactionStatus.PENDING
      && this.transaction.data.gateway === TransactionGateWay.CARD)
  }

}
